import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ILocation } from '../../api/types';

export interface IGeoLocationState {
    entry: ILocation;
    loading: boolean;
}

const initialState: IGeoLocationState = {
    entry: <ILocation>{},
    loading: true,
};

const geoLocationSlice = createSlice({
    name: 'charge',
    initialState,
    reducers: {
        changeGeoLocation: (state, data: PayloadAction<ILocation>): void => {
            state.entry = data.payload;
            state.loading = false;
        },
        clearGeoLocation: (state): void => {
            state.entry = initialState.entry;
            state.loading = true;
        },
        setGeoLocationLoading: (state, data: PayloadAction<boolean>): void => {
            state.loading = data.payload;
        },
    },
});

export const { changeGeoLocation, clearGeoLocation, setGeoLocationLoading } =
    geoLocationSlice.actions;
export const geoLocationReducer = geoLocationSlice.reducer;
